import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
	  keyWord: '',
  },
  mutations: {
	  setKeyWord(state,val){
	      state.keyWord = val;
	  },
  },
  actions: {},
  modules: {}
});
